import { createApp } from "vue";
import App from "./App.vue";
import "./scripts/commons";
import "element-plus/lib/theme-chalk/index.css";
import ElementPlus from "element-plus";
import "dayjs/locale/zh-cn";
import locale from "element-plus/lib/locale/lang/zh-cn";
import VueMsg from "./scripts/message";
import VueLang from "./scripts/lang";
import router from "./router";
import baseComponents from "./components/index";
import "./styles/ly-c.css";
import "./styles/sk-c.css";
import "./styles/icons.css";
import "./styles/site.css";
import VueAjax from "./scripts/ajax";
import dayjs from "./scripts/dayjs";
import auth from "./scripts/auth";

const VueAuth = {};
VueAuth.install = function (app) {
    app.mixin({
        beforeCreate() {
            this.$auth = auth;
        },
    });
};

createApp(App)
    .use(ElementPlus, { locale })
    .use(router)
    .use(VueLang)
    .use(VueAjax)
    .use(VueMsg)
    .use(VueAuth)
    .use(dayjs)
    .use(baseComponents)
    .mount("#app");
